import axios from 'axios';
//import config from '../../config';
import {config} from '../../config'
//import {history} from '../../store';


axios.interceptors.request.use(function (config) {
   const token = localStorage.getItem("userToken");
   if (token) {
     config.headers.Authorization = `Bearer ${token}`;
   }

   return config;
});

 
export const getUserAllApi = async()=>{
   const url = `${config.apiUrl}/v1/user/`;
   return await axios.get(url)
   .then(response => response.data).catch(err => {  return { status:false , error:err.response}  });
}
export const getUserAllOurOwnInstitutionsApi = async()=>{
   const url = `${config.apiUrl}/v1/user/OurOwnInstitutions/`;
   return await axios.get(url)
   .then(response => response.data).catch(err => {  return { status:false , error:err.response}  });
}
export const getUserAllInactiveUsersApi = async()=>{
   const url = `${config.apiUrl}/v1/user/inactiveUsers/`;
   return await axios.get(url)
   .then(response => response.data).catch(err => {  return { status:false , error:err.response}  });
}

export const getUserByUserIdApi = (userId)=>{
    const url = `${config.apiUrl}/v1/user/${userId}`;
    return axios.get(url)
    .then(response => response.data);
 }

 export const getInsisByUserIdApi = (userId)=>{
   const url = `${config.apiUrl}/v1/user/insis/${userId}`;
   return axios.get(url)
   .then(response => response.data);
}

 export const getUserByIdentityNoApi = (identityNo)=>{
   const url = `${config.apiUrl}/v1/user/identityNo/${identityNo}`;
   return axios.get(url)
   .then(response => response.data);
}
export const deleteUserByUserIdApi = (userId, opts = {})=>{
    const url = `${config.apiUrl}/v1/user/${userId}`;
    const params = {};
    if (opts && opts.forceGate) params.forceGate = 1;
    return axios.delete(url, { params })
    .then(response => response.data);
 }

 export const putUserUpdateApi =  (user)=>{
    const url = `${config.apiUrl}/v1/user/`;
    return axios.put(url,user)
    .then(response => response.data).catch(err => {  return { status:false , error:err.response}  });
 }
 export const putUserPasswordUpdateApi =  (user)=>{
   const url = `${config.apiUrl}/v1/user/password/`;
   return axios.put(url,user)
   .then(response => response.data).catch(err => {  return { status:false , error:err.response}  });
}
export const putUserPassword2UpdateApi =  (user)=>{
   const url = `${config.apiUrl}/v1/user/password2/`;
   return axios.put(url,user)
   .then(response => response.data).catch(err => {  return { status:false , error:err.response}  });
}
 export const getUserTokenApi =  (userId)=>{
   const url = `${config.apiUrl}/v1/user/getUserToken/${userId}`;
   return axios.get(url)
   .then(response => response.data).catch(err => {  return { status:false , error:err.response}  });
}


export const getUsersEXCELApi = ()=>{
   const url = `${config.apiUrl}/v1/excel/users`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob' 
   })
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
         return file;
   }).catch(err => {  return { status:false , error:err.response}  });
}

export const postCreateUserApi = async(user)=>{
   const token = localStorage.getItem("userTokenBilsis");
   const configAxios = { 
      headers: { Authorization: "Bearer " + token }
   }

    const url = `${config.apiUrl}/v1/user/newUser/otherApp`;
    return await axios.post(url,user,configAxios)
    .then(response => response.data)
 }

// ------------------------------------------------------------
// Mükerrer kullanıcı birleştirme (ÖNCE ÖZET/ONAY, sonra EXECUTE)
// ------------------------------------------------------------
export const postUserMergePreviewApi = async (userId1, userId2) => {
   const url = `${config.apiUrl}/v1/user/merge/preview`;
   return await axios
      .post(url, { userId1, userId2 })
      .then((response) => response.data)
      .catch((err) => {
         return { status: false, error: err.response };
      });
};

export const postUserMergeExecuteApi = async (primaryUserId, secondaryUserId) => {
   const url = `${config.apiUrl}/v1/user/merge/execute`;
   return await axios
      .post(url, { primaryUserId, secondaryUserId })
      .then((response) => response.data)
      .catch((err) => {
         return { status: false, error: err.response };
      });
};

export const searchPersonnelApi = async (searchTerm) => {
   const url = `${config.apiUrl}/v1/user/search/personnel`;
   return await axios
      .get(url, { params: { q: searchTerm } })
      .then((response) => response.data)
      .catch((err) => {
         return { status: false, error: err.response };
      });
};